import React, { useState } from 'react'
import PersonCard from './personCard/PersonCardWithoutOppSelect';

function PersonCardList({people,isSelectedRef,handleToggleSelect,dropDownData,totalFound}) {
  console.log("firsPersonCardListt",people)

     const [visibleCount, setVisibleCount] = useState(5);

      const visiblePeople = people?.slice(0, visibleCount) || [];


  return (
   people?.length > 0 ? (
          <div>
            <div className='mb-4'>Showing {visiblePeople.length} of {totalFound} contacts</div>
        
            {visiblePeople.map((person) => (
              <PersonCard
                key={person.id}
                person={person}
                isSelected={isSelectedRef.current.some((p) => p.id === person.id)}
                onSelectChange={handleToggleSelect}
                dropDownData={dropDownData}
              />
            ))}
            {people.length > visiblePeople.length && (
              <button className='find-opp-catagory-container-btn' onClick={() => setVisibleCount((prev) => prev + 5)}>
                Show More
              </button>
            )}
          </div>
        ) : (
          <>People Not Found. Please Retry</>
        )
  )
}

export default PersonCardList